import axios from 'axios';
import authService from './AuthService';

const API_BASE = (process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api').replace(/\/$/, '');
const API_URL = `${API_BASE}/history`;

const getHistory = () => {
    const tokenData = authService.getCurrentToken();
    const headers = {
        Authorization: `Bearer ${tokenData.access_token}`
    };
    return axios.get(API_URL + '/', { headers });
};

const historyService = {
    getHistory,
};

export default historyService;
